/**
 * @module geo/types
 */


/**
 * Represent an extent, a box.
 */
export interface ExtentOptions {
  minX: number;
  maxX: number;
  minY: number;
  maxY: number;
  /**
   * crs(( in epsg code )
   */
  crs: number;
}

/**
 * @private
 */
export abstract class ExtentA implements ExtentOptions {
  abstract minX: number;
  abstract maxX: number;
  abstract minY: number;
  abstract maxY: number;
  abstract crs: number;
}
